module.exports = "<div class=\"row\">\r\n    <div class=\"col-md-6 text-center\">\r\n        <i class=\"fa fa-fw fa-2x fa-shopping-cart\"></i><br/>\r\n        Go to Cart\r\n    </div>\r\n    <div class=\"col-md-6\">{{ ngCart.getTotalItems() }}\r\n        <ng-pluralize count=\"ngCart.getTotalItems()\" when=\"{1: 'item', 'other':'items'}\"></ng-pluralize>\r\n        <br />{{ ngCart.totalCost() | currency }}\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/ng-cart/summary.html
// module id = 1010
// module chunks = 0